<template>
<div class="relative">
	<v-form v-model="valid" ref="form">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
		<v-row class="ma-0" style="width: 100%;" align="center" justify="start">
			<v-col cols="12" sm="6" xs="6" md="6" lg="3" class="d-flex justify-start">
				<slot name="breadcrumbs"></slot>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="12" sm="6" xs="6" md="6" lg="2" class="d-flex justify-end">
				<bee-btn context="unit_size" :action-name="actions.CREATE" :disabled="file_is_locked" color="addingColor" :content="$t('UnitSizesPage.create-unit-size')" @click="addDialog = true"></bee-btn>
			</v-col>
			<v-dialog persistent v-model="addDialog" max-width="400px" transition="dialog-top-transition">
			<v-card>
				<v-card-title>
					{{ formTitle }}
				</v-card-title>

				<v-card-text class="pb-0">
					<v-row justify="center">
						<v-col cols="12" class="mx-5 pb-0">
							<bee-text-field context="unit_size" :action-name="actions.CREATE" v-model="row.name" :label="$t('UnitSizesPage.unit-size-name')" :rules="[rules.required]"></bee-text-field>
						</v-col>
						<v-col cols="12" class="mx-5 pb-0">
							<bee-text-field context="unit_size" :action-name="actions.CREATE" v-model="row.notes" :label="$t('UnitSizesPage.notes')"></bee-text-field>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions class="px-5">
					<v-btn color="greenDarken1" text @click="save()" :disabled="!valid">
						{{$t('UnitSizesPage.save')}}
					</v-btn>
					<v-btn color="redDarken1" text @click="reset()">
						{{$t('UnitSizesPage.cancel')}}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
			</v-dialog>
		</v-row>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
		<v-card flat>
			<v-card-text class="pt-0 px-3">
				<bee-simple-table empty-state="dashes"
					:fixed-header="true"
					context="unit_size" :action-name="actions.CREATE"
					@delete="selectedId = $event.id; deleteDialog = true" 
					@edit=" row ={...$event}; addDialog=true"
					:configs="configs" 
					:with-color="true" :zebra="false"  
					:hide-footer="true" :headers="file_is_locked ? headers_when_file_is_locked : headers" :items="unit_sizes">
				</bee-simple-table>
			</v-card-text>
		</v-card>
		<bee-dialog
		    :persistent="true"
		    @handler="confirmDelete()"
		    @close="reset()"
		    v-model="deleteDialog"
		    :title="$t('UnitSizesPage.delete-the-unit-size')"
		    :message="$t('UnitSizesPage.are-you-sure-you-want-to-delete-the-unit-size')"
		></bee-dialog>
		</div>
	</v-form>
</div>
</template>
<script>
import rules from "../../../validation";
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import actions from "../../../permissions/actions-names.js"
export default {
data: () => ({
	actions,
	deleteDialog: false,
	addDialog: false,
	valid: false,
	...rules,
	selectedId: null,
	row: {id: null, name: null, notes: null},
}),
mounted(){
	window.observer.observe(document.querySelector("#tool-bar"))
},
methods:{
	reset(){
		Object.keys(this.row).forEach(key => this.row[key] = null)
		this.addDialog = false
		this.deleteDialog = false
		this.$refs.form.resetValidation()
	},
	save(){
		if(!this.row.id)
			this.$store.dispatch("unitSizes/create", { unit_size: this.row } ).then(()=>{ store.dispatch("unitSizes/fetchAll") }).finally(() =>  this.reset())
		else
			this.$store.dispatch("unitSizes/update", { unit_size: this.row } ).then(()=>{ store.dispatch("unitSizes/fetchAll") }).finally(() =>  this.reset())
	},
	confirmDelete(){
		this.$store.dispatch("unitSizes/delete",{ id: this.selectedId }).then(()=>{ store.dispatch("unitSizes/fetchAll") }).finally(() =>  this.selectedId = null)
	},
},
computed: {
	...mapState("unitSizes" , ["unit_sizes"]),
	...mapState("configs" , ["configs"]),
	formTitle() {
		return !this.row.id ? this.$t('UnitSizesPage.create-unit-size') : this.$t('UnitSizesPage.edit-unit-size')
	},
	headers() {
		return [
			{
				text: this.$t('UnitSizesPage.headers.unit-size'),
				value: 'name',
				type: 'string',
				width: '30%',
				editable: true
			},
			{
				text: this.$t('UnitSizesPage.headers.notes'),
				value: 'notes',
				type: 'string',
				editable: true,
				width: '50%',
				settings: { itemText: 'name' }
			},
			{
				text: this.$t('UnitSizesPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%',
				actions: [
					{ name: 'edit', action_name: actions.EDIT}, 
					{ name: 'delete', action_name: actions.DELETE},  
				]
			}
		]
	},
	headers_when_file_is_locked() {
		return [
			{
				text: this.$t('UnitSizesPage.headers.unit-size'),
				value: 'name',
				type: 'string',
				width: '30%',
				editable: true
			},
			{
				text: this.$t('UnitSizesPage.headers.notes'),
				value: 'notes',
				type: 'string',
				editable: true,
				width: '50%',
				settings: { itemText: 'name' }
			},
			{
				text: this.$t('UnitSizesPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%',
				actions: []
			}
		]
	},
	file_is_locked(){ 
        return this.configs?.financial_file?.is_locked }
},
async beforeRouteEnter(to, from, next) {
	let promises = [store.dispatch('unitSizes/fetchAll')]

	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	if(promises.length)
		await Promise.all(promises)
	next();
}
};
</script>
<style scoped>

</style>